import FeedIcon from 'app/components/SVGS/FeedIcon'
import StoriesIcon from 'app/components/SVGS/StoriesIcon'
import LeaderBoardIcon from 'app/components/SVGS/LeaderBoardIcon'
import RisedHandsEmoji from 'app/components/SVGS/RisedHandsEmoji'
import HeartEmoji from 'app/components/SVGS/HeartEmoji'
import BlushEmoji from 'app/components/SVGS/BlushEmoji'
import FireEmoji from 'app/components/SVGS/FireEmoji'
import TadaEmoji from 'app/components/SVGS/TadaEmoji'
import LeaderBoardActiveIcon from 'app/components/SVGS/LeaderBoardActiveIcon'
import StoriesActiveIcon from 'app/components/SVGS/StoriesActiveIcon'
import FeedActiveIcon from 'app/components/SVGS/FeedActiveIcon'

export const SECTION_ACTIVITIES_COMPLETED = 'ACTIVITIES_COMPLETED'
export const SECTION_STREAK = 'STREAK'

export const SECTION_LINKS = [
  {
    title: 'Activities Completed',
    section: SECTION_ACTIVITIES_COMPLETED,
  },
  {
    title: 'Current Streak',
    section: SECTION_STREAK,
  },
]

export const TAB_RECENT = 'TAB_RECENT'
// TAB_LEADER_BOARD use as id In Tour
export const TAB_LEADER_BOARD = 'TAB_LEADER_BOARD'
export const TAB_STORIES = 'TAB_STORIES'

export const FEED_LINKS = [
  {
    title: 'Feed',
    tab: TAB_RECENT,
    icons: {
      default: FeedIcon,
      active: FeedActiveIcon,
    },
  },
  {
    title: 'Stories',
    tab: TAB_STORIES,
    icons: {
      default: StoriesIcon,
      active: StoriesActiveIcon,
    },
  },
  {
    title: 'Leaderboard',
    tab: TAB_LEADER_BOARD,
    icons: {
      default: LeaderBoardIcon,
      active: LeaderBoardActiveIcon,
    },
  },
]

export const ACTION_NAME_COMMIT = 'commited'
export const ACTION_NAME_STARTED = 'started'
export const ACTION_NAME_FINISHED = 'finished'
export const ACTION_NAME_DID = 'did'
export const ACTION_NAME_BADGE_ACHIEVEMENT = 'badgeAchievement'
export const ACTION_NAME_ACHIEVEMENT = 'achievement'

export const PROTRACK_ACTIONS = [ACTION_NAME_STARTED, ACTION_NAME_FINISHED]
export const ACTIVITY_ACTIONS = [ACTION_NAME_COMMIT, ACTION_NAME_DID]

export const ACTION_NAMES = {
  [ACTION_NAME_COMMIT]: {
    title: 'Committed to',
  },
  [ACTION_NAME_STARTED]: {
    title: 'Started',
  },
  [ACTION_NAME_FINISHED]: {
    title: 'Finished',
  },
  [ACTION_NAME_DID]: {
    title: 'Finished',
  },
  [ACTION_NAME_BADGE_ACHIEVEMENT]: {
    title: 'Earned the',
  },
}

export const FEED_RANGE = {
  all: '0',
  week: '7',
  month: '30',
}

export const FEED_FILTER_INITIAL = 'no-teams'
export const FEED_FILTER = 'company'
export const FEED_FILTER_TEAMS = 'teams'

export const EMOJI_HEART = 'heart'
export const EMIJI_FIRE = 'fire'
export const EMIJI_BLUSH = 'blush'
export const EMIJI_RAISED_HANDS = 'raised-hands'
export const EMIJI_TADA = 'tada'

export const EMOJIS = [
  {
    name: EMOJI_HEART,
    icon: HeartEmoji,
  },
  {
    name: EMIJI_FIRE,
    icon: FireEmoji,
  },
  {
    name: EMIJI_BLUSH,
    icon: BlushEmoji,
  },
  {
    name: EMIJI_RAISED_HANDS,
    icon: RisedHandsEmoji,
  },
  {
    name: EMIJI_TADA,
    icon: TadaEmoji,
  },
]
